export default "__VITE_ASSET__00ba5e8d__"